import React from 'react'
import './porfolio.css'
import img from '../../assets/shopping.png'
import img2 from '../../assets/world.png'
import img3 from '../../assets/img3.png'
import img4 from '../../assets/DIGICom.png'
import img7 from '../../assets/silico.png'
import img8 from "../../assets/dilam.png";
import { useLanguage } from '../../contexts/LanguageContext';
import { translations } from '../../translations/translations';
import { motion } from 'framer-motion';
const Portfolio = () => {
  const { language } = useLanguage();
  const t = translations[language];
  
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 50, scale: 0.8 },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        duration: 0.6,
        type: "spring",
        stiffness: 100
      }
    }
  };

  return (
    <section id="portfolio">
      <motion.h5
        initial={{ opacity: 0, y: -50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        {t.portfolioSubtitle}
      </motion.h5>

      <motion.h2
        initial={{ opacity: 0, y: -50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.2 }}
        viewport={{ once: true }}
      >
        {t.portfolioTitle}
      </motion.h2>

      <div className="container portfolio__container">
        <motion.div
          className="portfolio__articles"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <motion.article
            className="portfolio__article"
            variants={itemVariants}
            whileHover={{
              scale: 1.05,
              y: -10,
              transition: { duration: 0.3 },
            }}
            whileTap={{ scale: 0.95 }}
          >
            <div className="portfolio__article-img">
              <img src={img2} className="img__site" alt="site2" />
            </div>
            <h3>WOrld Docs</h3>
          </motion.article>
          <motion.article
            className="portfolio__article"
            variants={itemVariants}
            whileHover={{
              scale: 1.05,
              y: -10,
              transition: { duration: 0.3 },
            }}
            whileTap={{ scale: 0.95 }}
          >
            <div className="portfolio__article-img">
              <img src={img} className="img__site" alt="site1" />
            </div>
            <h3>ElectroShopping</h3>
          </motion.article>

          <motion.article
            className="portfolio__article"
            variants={itemVariants}
            whileHover={{
              scale: 1.05,
              y: -10,
              transition: { duration: 0.3 },
            }}
            whileTap={{ scale: 0.95 }}
          >
            <div className="portfolio__article-img">
              <img src={img7} className="img__site" alt="site4" />
            </div>
            <h3>SilicoDB</h3>
          </motion.article>

          <motion.article
            className="portfolio__article"
            variants={itemVariants}
            whileHover={{
              scale: 1.05,
              y: -10,
              transition: { duration: 0.3 },
            }}
            whileTap={{ scale: 0.95 }}
          >
            <div className="portfolio__article-img">
              <img src={img4} className="img__site" alt="site4" />
            </div>
            <h3>DIGICom</h3>
          </motion.article>

          <motion.article
            className="portfolio__article"
            variants={itemVariants}
            whileHover={{
              scale: 1.05,
              y: -10,
              transition: { duration: 0.3 },
            }}
            whileTap={{ scale: 0.95 }}
          >
            <div className="portfolio__article-img">
              <img src={img8} className="img__site" alt="site4" />
            </div>
            <h3>DIlam Consulting</h3>
          </motion.article>

          <motion.article
            className="portfolio__article"
            variants={itemVariants}
            whileHover={{
              scale: 1.05,
              y: -10,
              transition: { duration: 0.3 },
            }}
            whileTap={{ scale: 0.95 }}
          >
            <div className="portfolio__article-img">
              <img src={img3} className="img__site" alt="site3" />
            </div>
            <h3>Calculatrice</h3>
          </motion.article>
        </motion.div>
      </div>
    </section>
  );
}

export default Portfolio